// frontend/src/components/capacitor/CapacitorMediaSheet.tsx
import { Drawer } from 'vaul'
import { PreviewOptions } from '../../types/preview'
import './Capacitor.css'

type MediaMode = PreviewOptions['mediaMode']

interface MediaOption {
  mode: MediaMode
  name: string
  desc: string
}

const OPTIONS: MediaOption[] = [
  {
    mode: 'both',
    name: 'Thumbnail + Dateiname',
    desc: 'Bild eingebettet + Dateiname als Text',
  },
  {
    mode: 'thumbnail',
    name: 'Nur Thumbnails',
    desc: 'Bild eingebettet, kompakt',
  },
  {
    mode: 'hidden',
    name: 'Medien ausblenden',
    desc: 'Reines Text-PDF, keine Bilder',
  },
]

interface Props {
  mediaMode: MediaMode
  onSelect: (mode: MediaMode) => void
  onClose: () => void
}

export function CapacitorMediaSheet({ mediaMode, onSelect, onClose }: Props) {
  return (
    <Drawer.Root open={true} onOpenChange={v => { if (!v) onClose() }}>
      <Drawer.Portal>
        <Drawer.Overlay className="cp-drawer-overlay" />
        <Drawer.Content className="cp-drawer">
          <div className="cp-drawer-handle" />
          <Drawer.Title className="cp-drawer-title">Medien-Anzeige</Drawer.Title>

          <div className="cp-drawer-body">
            {OPTIONS.map((option) => (
              <div
                key={option.mode}
                className={`cap-media-option ${mediaMode === option.mode ? 'selected' : ''}`}
                onClick={() => onSelect(option.mode)}
              >
                <div className="cap-media-option-radio" />
                <div className="cap-media-option-body">
                  <div className="cap-media-option-name">{option.name}</div>
                  <div className="cap-media-option-desc">{option.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
}
